import servicemodal from "./servicemodal.json";
import systemResources from "./systemresources.json";
import announcements from "./announcements.json";

import appointments from "./appointments.json";

import audio from "./audio.json";

import auth from "./auth.json";

import avatarupload from "./avatarupload.json";

import backendErrors from "./backendErrors.json";

import birthdaysettings from "./birthdaysettings.json";

import botmonitor from "./botmonitor.json";

import campaignreport from "./campaignreport.json";

import campaigns from "./campaigns.json";

import campaignsconfig from "./campaignsconfig.json";

import campaignsphrase from "./campaignsphrase.json";
import metaComments from "./metaComments.json";


import changeslog from "./changeslog.json";

import chat from "./chat.json";

import chatindex from "./chatindex.json";

import chatlist from "./chatlist.json";

import chatmessages from "./chatmessages.json";

import common from "./common.json";

import checkout from "./checkout.json";

import compaies from "./compaies.json";

import companymodal from "./companymodal.json";

import confirmationmodal from "./confirmationmodal.json";

import connections from "./connections.json";

import contactdeleteconfirmmodal from "./contactdeleteconfirmmodal.json";

import contactdrawer from "./contactdrawer.json";

import contactimportwpmodal from "./contactimportwpmodal.json";

import contactlist from "./contactlist.json";

import contactlistitems from "./contactlistitems.json";

import contactlists from "./contactlists.json";

import contactmodal from "./contactmodal.json";

import contacts from "./contacts.json";

import dashboard from "./dashboard.json";

import dates from "./dates.json";

import etapa_kanban from "./etapa_kanban.json";

import filemodal from "./filemodal.json";

import files from "./files.json";

import finance from "./finance.json";

import financial from "./financial.json";

import floup from "./floup.json";

import floupdashboard from "./floupdashboard.json";

import flowbuilder from "./flowbuilder.json";

import flowdefault from "./flowdefault.json";

import eventWebhooks from "./eventWebhooks.json";

import followup from "./followup.json";

import frontenderrors from "./frontenderrors.json";

import global from "./global.json";

import helps from "./helps.json";

import kanban from "./kanban.json";

import languages from "./languages.json";

import layout from "./layout.json";

import login from "./login.json";

import maindrawer from "./maindrawer.json";

import manual from "./manual.json";

import messageinput from "./messageinput.json";

import messagemodal from "./messagemodal.json";

import messageoptionsmenu from "./messageoptionsmenu.json";

import messages from "./messages.json";

import messagesapi from "./messagesapi.json";

import messagesapiinstructions from "./messagesapiinstructions.json";

import messagesinput from "./messagesinput.json";

import messageslist from "./messageslist.json";

import messagevariablespicker from "./messagevariablespicker.json";

import momentsuser from "./momentsuser.json";

import newticketmodal from "./newticketmodal.json";

import notifications from "./notifications.json";

import plans from "./plans.json";

import professionalmodal from "./professionalmodal.json";

import promptmodal from "./promptmodal.json";

import prompts from "./prompts.json";

import publicbooking from "./publicbooking.json";

import qrcode from "./qrcode.json";

import queueintegration from "./queueintegration.json";

import queueintegrationmodal from "./queueintegrationmodal.json";

import queuemodal from "./queuemodal.json";

import queues from "./queues.json";

import queueselect from "./queueselect.json";

import quickmessages from "./quickmessages.json";

import recurrencesection from "./recurrencesection.json";

import reports from "./reports.json";

import salesreport from "./salesreport.json";

import schedulemodal from "./schedulemodal.json";

import schedules from "./schedules.json";

import sendcontactmodal from "./sendcontactmodal.json";

import servicepanel from "./servicepanel.json";

import settings from "./settings.json";

import showticketlogmodal from "./showticketlogmodal.json";

import showticketopenmodal from "./showticketopenmodal.json";

import signup from "./signup.json";

import statusfilter from "./statusfilter.json";

import tagmodal from "./tagmodal.json";

import tags from "./tags.json";

import tagskanban from "./tagskanban.json";

import ticketinfo from "./ticketinfo.json";

import ticketlist from "./ticketlist.json";

import ticketoptionsmenu from "./ticketoptionsmenu.json";

import tickets from "./tickets.json";

import ticketslist from "./ticketslist.json";

import ticketsmanager from "./ticketsmanager.json";

import ticketsqueueselect from "./ticketsqueueselect.json";

import ticketstatus from "./ticketstatus.json";

import toasterror from "./toasterror.json";

import todo from "./todo.json";

import transferticketconnectionmodal from "./transferticketconnectionmodal.json";

import transferticketmodal from "./transferticketmodal.json";

import triggerflowmodal from "./triggerflowmodal.json";

import usermodal from "./usermodal.json";

import users from "./users.json";

import adminReseller from "./adminReseller.json";

import versioncontrol from "./versioncontrol.json";

import wallets from "./wallets.json";

import webhookmodal from "./webhookmodal.json";

import weekdays from "./weekdays.json";

import whatsappmodal from "./whatsappmodal.json";

import whatsappmodalrel from "./whatsappmodalrel.json";

import whitelabel from "./whitelabel.json";

import webWidgets from "./webWidgets.json";

import aipackages from "./aipackages.json";
import pagehelpguide from "./pagehelpguide.json";


const translations = {
  ...systemResources,
  ...announcements,
  ...appointments,
  ...audio,
  ...auth,
  ...avatarupload,
  ...backendErrors,
  ...birthdaysettings,
  ...botmonitor,
  ...campaignreport,
  ...campaigns,
  ...campaignsconfig,
  ...campaignsphrase,

  ...changeslog,
  ...chat,
  ...chatindex,
  ...chatlist,
  ...chatmessages,
  ...common,
  ...checkout,
  ...compaies,
  ...companymodal,
  ...confirmationmodal,
  ...connections,
  ...contactdeleteconfirmmodal,
  ...contactdrawer,
  ...contactimportwpmodal,
  ...contactlist,
  ...contactlistitems,
  ...contactlists,
  ...contactmodal,
  ...contacts,
  ...dashboard,
  ...dates,
  ...etapa_kanban,
  ...filemodal,
  ...files,
  ...finance,
  ...financial,
  ...floup,
  ...floupdashboard,
  ...flowbuilder,
  ...flowdefault,
  ...eventWebhooks,
  ...followup,
  ...frontenderrors,
  ...global,
  ...helps,
  ...kanban,
  ...languages,
  ...layout,
  ...login,
  ...maindrawer,
  ...manual,
  ...messageinput,
  ...messagemodal,
  ...messageoptionsmenu,
  ...messages,
  ...messagesapi,
  ...messagesapiinstructions,
  ...metaComments,
  ...messagesinput,
  ...messageslist,
  ...messagevariablespicker,
  ...momentsuser,
  ...newticketmodal,
  ...notifications,
  ...plans,
  ...professionalmodal,
  ...promptmodal,
  ...prompts,
  ...publicbooking,
  ...qrcode,
  ...queueintegration,
  ...queueintegrationmodal,
  ...queuemodal,
  ...queues,
  ...queueselect,
  ...quickmessages,
  ...recurrencesection,
  ...reports,
  ...salesreport,
  ...schedulemodal,
  ...schedules,
  ...sendcontactmodal,
  ...servicemodal,
  ...servicepanel,
  ...settings,
  ...showticketlogmodal,
  ...showticketopenmodal,
  ...signup,
  ...statusfilter,
  ...tagmodal,
  ...tags,
  ...tagskanban,
  ...ticketinfo,
  ...ticketlist,
  ...ticketoptionsmenu,
  ...tickets,
  ...ticketslist,
  ...ticketsmanager,
  ...ticketsqueueselect,
  ...ticketstatus,
  ...toasterror,
  ...todo,
  ...transferticketconnectionmodal,
  ...transferticketmodal,
  ...triggerflowmodal,
  ...usermodal,
  ...users,
  ...adminReseller,
  ...versioncontrol,
  ...wallets,
  ...webhookmodal,
  ...weekdays,
  ...whatsappmodal,
  ...whatsappmodalrel,
  ...whitelabel,
  ...webWidgets,
  ...aipackages,
  ...pagehelpguide,
};

export default translations;
